export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/xml, text/xml, .xml, .ofx, .sped, .nli,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const CSAT_DISPLAY_TYPES = {
  EMOJI: 'emoji',
  STAR: 'star',
};

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  { label: 'MESSAGE_VARIABLES.CONVERSATION_ID', key: 'conversation.id' },
  {
    label: 'MESSAGE_VARIABLES.CONVERSATION_DISPLAY_ID',
    key: 'conversation.display_id',
  },
  { label: 'MESSAGE_VARIABLES.CONTACT_ID', key: 'contact.id' },
  { label: 'MESSAGE_VARIABLES.CONTACT_NAME', key: 'contact.name' },
  { label: 'MESSAGE_VARIABLES.CONTACT_FIRST_NAME', key: 'contact.first_name' },
  { label: 'MESSAGE_VARIABLES.CONTACT_LAST_NAME', key: 'contact.last_name' },
  { label: 'MESSAGE_VARIABLES.CONTACT_EMAIL', key: 'contact.email' },
  { label: 'MESSAGE_VARIABLES.CONTACT_PHONE', key: 'contact.phone' },
  { label: 'MESSAGE_VARIABLES.AGENT_NAME', key: 'agent.name' },
  { label: 'MESSAGE_VARIABLES.AGENT_FIRST_NAME', key: 'agent.first_name' },
  { label: 'MESSAGE_VARIABLES.AGENT_LAST_NAME', key: 'agent.last_name' },
  { label: 'MESSAGE_VARIABLES.AGENT_EMAIL', key: 'agent.email' },
  { label: 'MESSAGE_VARIABLES.INBOX_NAME', key: 'inbox.name' },
  { label: 'MESSAGE_VARIABLES.INBOX_ID', key: 'inbox.id' },
  { label: 'MESSAGE_VARIABLES.COMPANY_NAME', key: 'company.name' },
  { label: 'MESSAGE_VARIABLES.COMPANY_DOCUMENT', key: 'company.document' },
  { label: 'MESSAGE_VARIABLES.DEBT_DUE_DATE', key: 'debt.due_date' },
  {
    label: 'MESSAGE_VARIABLES.DEBT_REMAINING_AMOUNT',
    key: 'debt.remaining_amount',
  },
  { label: 'MESSAGE_VARIABLES.DEBT_TOTAL_AMOUNT', key: 'debt.total_amount' },
  {
    label: 'MESSAGE_VARIABLES.DEBT_DOCUMENT_FISCAL',
    key: 'debt.document_fiscal',
  },
];

const EMAIL_CAMPAIGN_VARIABLE_KEYS = [
  'contact.name',
  'contact.first_name',
  'contact.last_name',
  'contact.email',
  'company.name',
  'company.document',
];

export const EMAIL_CAMPAIGN_VARIABLES = MESSAGE_VARIABLES.filter(variable =>
  EMAIL_CAMPAIGN_VARIABLE_KEYS.includes(variable.key)
);

const EMAIL_CAMPAIGN_SUBJECT_VARIABLE_KEYS = [
  'contact.first_name',
  'contact.name',
];

export const EMAIL_CAMPAIGN_SUBJECT_VARIABLES = MESSAGE_VARIABLES.filter(
  variable => EMAIL_CAMPAIGN_SUBJECT_VARIABLE_KEYS.includes(variable.key)
);

const WHATSAPP_TEMPLATE_VARIABLE_KEYS = [
  'contact.id',
  'contact.name',
  'contact.first_name',
  'contact.last_name',
  'contact.email',
  'contact.phone',
  'agent.name',
  'agent.first_name',
  'agent.last_name',
  'agent.email',
  'inbox.name',
  'inbox.id',
  'conversation.id',
  'company.name',
  'company.document',
];

export const WHATSAPP_TEMPLATE_VARIABLES = MESSAGE_VARIABLES.filter(variable =>
  WHATSAPP_TEMPLATE_VARIABLE_KEYS.includes(variable.key)
);

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};
